import React, { useState, useEffect } from 'react';
import './LandingPage.css';

type Language = 'he' | 'en';

const translations = {
  he: {
    headerContact: 'שיחה עם נציג',
    headerLogin: 'כניסה',
    heroTitle: 'שליטה על כל משלוח.',
    heroTitleBreak: 'בכל רגע.',
    heroSubtitle: 'Bali Drive • מערכת חכמה לניהול שליחים בזמן אמת',
    heroDescription: '',
    heroCTA: 'התחל עכשיו',
    heroDemo: 'צפה בדמו',
    heroSubtext: '',
    heroBenefits: [],
    solutionsLabel: 'פתרונות',
    solutionsTitle: 'משלוחים בטכנולוגיה מתקדמת',
    solutionsDescription: 'פתרונות משלוחים חדשניים המשלבים את הטכנולוגיה המובילה בתחום. המערכת שלנו מאפשרת שליטה מרחוק בזמני המשלוח, מעקב מדויק אחר כל משלוח, וניתוח מעמיק שעוזר לכם לבנות את המערך האופטימלי עבור העסק.',
    threeAppsLabel: 'הפלטפורמה',
    threeAppsTitle: '3 אפליקציות. פלטפורמה אחת.',
    threeAppsDescription: 'כל מרכיב במערכת תוכנן במיוחד עבור התפקיד שלו — עסקים, שליחים ומנהלים, כולם עובדים מאותה מערכת מסונכרנת.',
    shopAppTitle: 'אפליקציה לעסק',
    shopAppSub: 'Shop App',
    shopAppDesc: 'ניהול הזמנות, מעקב אחר משלוחים, תקשורת ישירה עם שליחים ודוחות בזמן אמת — הכל מהטלפון.',
    driverAppTitle: 'אפליקציה לשליח',
    driverAppSub: 'Driver App',
    driverAppDesc: 'ניווט חכם, רשימת משלוחים מעודכנת, תקשורת עם העסק והלקוח, וניהול סטטוס המשלוח בקליק אחד.',
    managerAppTitle: 'אפליקציה למנהל',
    managerAppSub: 'Manager App',
    managerAppDesc: 'שליטה מלאה במערך השליחויות, ציוות אוטומטי, מעקב בזמן אמת, ניהול שליחים ותפעול יעיל מכל מקום.',
    restaurantsLabel: 'מסעדות',
    restaurantsTitle: 'ייעול משלוחים והגדלת רווחים',
    restaurantsDescription: 'באלי עוזרת למסעדות להתמודד עם אתגרי הלוגיסטיקה ולשפר את חווית השירות. אנו עובדים בשיתוף פעולה עם חברות משלוחים מובילות, מה שמאפשר לנו להציע מערך משלוחים אפקטיבי ויעיל.',
    restaurantsCTA: 'התחבר היום ←',
    deliveryLabel: 'חברות משלוחים',
    deliveryTitle: 'ניהול שליחים בזמן אמת',
    deliveryDescription: 'באלי מתמחה בניהול שליחים בזמן אמת ועובדת עם אנדרואיד, iOS או מהמחשב. תוכלו לשלוט בשליחים, לנהל תזמוני משלוחים בצורה מדויקת ולקבוע את המסלולים האופטימליים. המערכת שלנו כוללת ציוות אוטומטי חכם המבוסס על בינה מלאכותית.',
    deliveryCTA: 'פתח חשבון ←',
    customLabel: 'התאמה אישית',
    customTitle: 'הכל במיוחד עבורך',
    customDescription: 'בבאלי, אנו מאמינים שכל עסק ייחודי ומצריך פתרון משלוחים המותאם אישית לצרכיו. לכן אנו מציעים גישה מותאמת אישית לניהול משלוחים, המאפשרת לך לבנות אסטרטגיה מנצחת.',
    automationTitle: 'אוטומציה וחווית לקוח',
    automationDesc: 'הגדילו רווחים על ידי חיסכון בכוח אדם מיותר והגדילו הכנסות דרך חווית לקוח שתחזיר את הלקוחות אליכם שוב ושוב.',
    testimonialsLabel: 'המלצות',
    testimonialsTitle: 'מה הלקוחות אומרים עלינו',
    coverageLabel: 'פריסה ארצית',
    coverageTitle: 'מדרום ועד צפון - באלי במקום הראשון',
    coverageDescription: 'באלי פועלת בשיתוף פעולה עם חברות משלוחים מובילות ומכסה את כל רחבי ישראל מצפון לדרום.',
    contactTitle: 'רוצים לראות את Bali Drive בפעולה?',
    contactSub: 'השאירו פרטים ונחזור אליכם',
    contactName: 'שם מלא',
    contactCity: 'עיר',
    contactPhone: 'טלפון',
    contactSubmit: 'שליחה',
    contactBusiness: 'עסק',
    contactCourier: 'שליח',
    contactRestaurant: 'מסעדה',
    finalCTA: 'הצטרפו למאות עסקים שבחרו להתקדם יחד עם באלי',
    finalBtn: 'השאירו פרטים',
    stat1: 'שליחים פעילים',
    stat2: 'עסקים משתמשים',
    stat3: 'משלוחים ביום',
    clientsLabel: 'מאות עסקים בוטחים בבאלי',
  },
  en: {
    headerContact: 'Contact Us',
    headerLogin: 'Login',
    heroTitle: 'Control every delivery.',
    heroTitleBreak: 'At any moment.',
    heroSubtitle: 'Bali Drive • Smart real-time delivery management system',
    heroDescription: '',
    heroCTA: 'Start Now',
    heroDemo: 'Watch Demo',
    heroSubtext: '',
    heroBenefits: [],
    solutionsLabel: 'Solutions',
    solutionsTitle: 'Deliveries with Advanced Technology',
    solutionsDescription: 'Innovative delivery solutions combining leading technology. Our system enables remote control over delivery times, precise tracking of every delivery, and deep analysis that helps you build the optimal setup for your business.',
    threeAppsLabel: 'The Platform',
    threeAppsTitle: '3 Apps. One Platform.',
    threeAppsDescription: 'Every component is designed specifically for its role — businesses, drivers, and managers all work from the same synchronized system.',
    shopAppTitle: 'Shop App',
    shopAppSub: 'Business App',
    shopAppDesc: 'Order management, delivery tracking, direct communication with drivers and real-time reports — all from your phone.',
    driverAppTitle: 'Driver App',
    driverAppSub: 'Courier App',
    driverAppDesc: 'Smart navigation, updated delivery list, communication with shop and customer, one-click status management.',
    managerAppTitle: 'Manager App',
    managerAppSub: 'Admin App',
    managerAppDesc: 'Full control of delivery operations, auto-dispatch, real-time tracking, driver management and efficient operations from anywhere.',
    restaurantsLabel: 'Restaurants',
    restaurantsTitle: 'Optimize Deliveries & Increase Profits',
    restaurantsDescription: 'Bali helps restaurants tackle logistics challenges and improve service quality. We partner with leading delivery companies, offering an effective and efficient delivery system.',
    restaurantsCTA: 'Join Today →',
    deliveryLabel: 'Delivery Companies',
    deliveryTitle: 'Real-time Courier Management',
    deliveryDescription: 'Bali specializes in real-time courier management across Android, iOS and desktop. Control your couriers, manage precise delivery schedules and set optimal routes. Our system includes smart AI-based automatic dispatch.',
    deliveryCTA: 'Open Account →',
    customLabel: 'Customization',
    customTitle: 'Everything Custom for You',
    customDescription: 'At Bali, we believe every business is unique and requires a custom delivery solution. We offer a personalized approach to delivery management, enabling you to build a winning strategy.',
    automationTitle: 'Automation & Customer Experience',
    automationDesc: 'Increase profits by saving on unnecessary labor and grow revenue through customer experiences that keep them coming back.',
    testimonialsLabel: 'Testimonials',
    testimonialsTitle: 'What Our Clients Say',
    coverageLabel: 'National Coverage',
    coverageTitle: 'From South to North — Bali Leads the Way',
    coverageDescription: 'Bali partners with leading delivery companies and covers all of Israel from north to south.',
    contactTitle: 'Want to see Bali Drive in action?',
    contactSub: 'Leave your details and we\'ll get back to you',
    contactName: 'Full Name',
    contactCity: 'City',
    contactPhone: 'Phone',
    contactSubmit: 'Submit',
    contactBusiness: 'Business',
    contactCourier: 'Courier',
    contactRestaurant: 'Restaurant',
    finalCTA: 'Join hundreds of businesses moving forward with Bali',
    finalBtn: 'Get Started',
    stat1: 'Active Couriers',
    stat2: 'Partner Businesses',
    stat3: 'Daily Deliveries',
    clientsLabel: 'Trusted by Hundreds of Businesses',
  }
};

const testimonials = [
  { name: 'יוסי כהן', nameEn: 'Yossi Cohen', role: 'בעלים, פיצה עגבניה', roleEn: 'Owner, Pizza Agvania', text: 'באלי עזרה לנו להגדיל את מכירות המשלוחים ב-40% תוך שלושה חודשים. המערכת קלה לשימוש והשירות מעולה!', textEn: 'Bali increased our delivery sales by 40% in three months. Easy to use with excellent service!' },
  { name: 'רונית לוי', nameEn: 'Ronit Levi', role: 'מנהלת, בורגרס בר', roleEn: 'Manager, Burgers Bar', text: 'החיבור עם חברות המשלוחים החיצוניות חוסך לנו המון זמן וכסף. הלקוחות שלנו מרוצים מזמני האספקה המהירים.', textEn: 'Integration with external delivery companies saves us time and money. Our customers love the fast delivery times.' },
  { name: 'אבי דוד', nameEn: 'Avi David', role: 'מנכ"ל, משלוחי המרכז', roleEn: 'CEO, Central Deliveries', text: 'הטכנולוגיה של באלי ייעלה את העבודה שלנו בצורה משמעותית. הניהול בזמן אמת חוסך טעויות והמון כאב ראש.', textEn: 'Bali\'s technology significantly streamlined our operations. Real-time management saves errors and headaches.' },
  { name: 'מיכל ברק', nameEn: 'Michal Barak', role: 'בעלת, סושי טוקיו', roleEn: 'Owner, Sushi Tokyo', text: 'הדוחות והסטטיסטיקות עזרו לנו להבין איפה אנחנו מפסידים כסף ולייעל את מערך המשלוחים. מומלץ בחום!', textEn: 'Reports and statistics helped us understand where we lose money and optimize our delivery operations. Highly recommended!' },
  { name: 'דני שמעון', nameEn: 'Dani Shimon', role: 'סמנכ"ל תפעול, רשת קפה קפה', roleEn: 'COO, Cafe Cafe Chain', text: 'אנחנו משתמשים בבאלי בכל הסניפים שלנו. המערכת יציבה, מהירה והשירות מקצועי.', textEn: 'We use Bali across all branches. The system is stable, fast and the service is professional.' },
  { name: 'שרון אברהם', nameEn: 'Sharon Avraham', role: 'בעלים, שליח אקספרס', roleEn: 'Owner, Express Courier', text: 'הציוות האוטומטי של השליחים חוסך לנו שעות עבודה כל יום. התוכנה פשוט עושה את העבודה בשבילנו!', textEn: 'Automatic driver dispatch saves us hours of work every day. The software just does the work for us!' },
];

const clientLogos = [
  { name: 'פיצה עגבניה', color: '#d32f2f' },
  { name: 'בורגרס בר', color: '#e65100' },
  { name: 'סושי טוקיו', color: '#1565c0' },
  { name: 'קפה קפה', color: '#4e342e' },
  { name: 'דגי רוני', color: '#0277bd' },
  { name: 'לחמני', color: '#ef6c00' },
  { name: 'סעדה דגים', color: '#00838f' },
  { name: 'שפע פרי', color: '#2e7d32' },
  { name: 'סקובר מרינה', color: '#6a1b9a' },
  { name: 'משלוחי המרכז', color: '#c62828' },
  { name: 'שליח אקספרס', color: '#f57f17' },
  { name: 'MOSES', color: '#37474f' },
  { name: 'נדב השניצל', color: '#ff8f00' },
  { name: 'אופוריה', color: '#ad1457' },
];

const LandingPage: React.FC = () => {
  const [language, setLanguage] = useState<Language>('he');
  const [formData, setFormData] = useState({ name: '', businessType: 'עסק', city: '', phone: '' });

  const t = translations[language];
  const isRtl = language === 'he';

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll('.scroll-animate').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert('תודה על פנייתך! נחזור אליך בהקדם');
    setFormData({ name: '', businessType: 'עסק', city: '', phone: '' });
  };

  return (
    <div className="landing-page" dir={isRtl ? 'rtl' : 'ltr'}>
      {/* Floating Background Shapes */}
      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>

      {/* Header - Sticky Pink Gradient */}
      <header className="landing-header">
        <div className="header-content">
          <div className="logo">
            <h1>Bali</h1>
            <p className="tagline">כל מה שבא לי</p>
          </div>
          <nav className="nav-buttons">
            <button className="btn-lang" onClick={() => setLanguage(language === 'he' ? 'en' : 'he')}>
              {language === 'he' ? 'EN' : 'עב'}
            </button>
            <button className="btn-secondary">{t.headerContact}</button>
            <button className="btn-primary">{t.headerLogin}</button>
          </nav>
        </div>
      </header>

      {/* Hero Section - Neon City Background */}
      <section className="hero-section" style={{ backgroundImage: "url('/hero-bg-neon-motorcycles.png')" }}>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-image">
            <div className="mockup-container-neon">
              <img src="/dashboard.png" alt="Bali Dashboard" className="dashboard-mockup-neon float-animation-delayed" />
              <img src="/driver-map-app.png" alt="Bali Mobile App" className="phone-mockup-neon float-animation" />
            </div>
          </div>
          <div className="hero-text fade-in-up">
            <h2 className="hero-title">
              {t.heroTitle}
              <br />
              {t.heroTitleBreak}
            </h2>
            <p className="hero-subtitle-neon">{t.heroSubtitle}</p>
            <div className="hero-cta-row">
              <button className="btn-hero-primary">{t.heroCTA}</button>
              <button className="btn-hero-secondary">{t.heroDemo}</button>
            </div>
            <div className="hero-logos-inline">
              <img src="/logos/1f430c4f457e4c3d069dc68d42c7f25f-72600f75-5c89-4a63-bb74-7974aa94c11d.png" alt="Wolt" />
              <img src="/logos/1de9b96d4b232eeb21d34f5270915847-fc94815b-ffa3-4f44-8661-3962faa4e4d7.png" alt="Domino's" />
              <img src="/logos/d7b04853d897ebe78aaba7a5c07e2ffa-7977565c-df53-4b8d-8dc0-ceea30dffcc9.png" alt="Pizza Hut" />
            </div>
          </div>
        </div>
      </section>

      {/* Business Carousel Section */}
      <section className="business-carousel-section">
        <h3 className="carousel-title">{isRtl ? 'מאות עסקים כבר עובדים איתנו' : 'Trusted by hundreds of businesses'}</h3>
        <div className="carousel-container">
          <div className="carousel-track">
            {/* First set of logos */}
            <div className="carousel-logo"><img src="/logos/1f430c4f457e4c3d069dc68d42c7f25f-72600f75-5c89-4a63-bb74-7974aa94c11d.png" alt="Business Logo" /></div>
            <div className="carousel-logo"><img src="/logos/Golda_Glida_Logo-290b2c2f-7cc8-4d4d-8c64-16f23710bca7.png" alt="Golda Logo" className="golda-logo" /></div>
            <div className="carousel-logo"><img src="/logos/1de9b96d4b232eeb21d34f5270915847-fc94815b-ffa3-4f44-8661-3962faa4e4d7.png" alt="Business Logo" /></div>
            <div className="carousel-logo"><img src="/logos/d7b04853d897ebe78aaba7a5c07e2ffa-7977565c-df53-4b8d-8dc0-ceea30dffcc9.png" alt="Business Logo" /></div>
            <div className="carousel-logo"><img src="/logos/Logo-Vector-02-61b74198-2798-48e2-866e-a44bdecd7e08.png" alt="Business Logo" /></div>
            <div className="carousel-logo"><img src="/logos/180039-daf31bdb-362b-480b-93ff-d2fa761d7b88.png" alt="Business Logo" /></div>
            <div className="carousel-logo"><img src="/logos/1320aaf2488d1018360e55b4ad2c772d-e507d50a-6f34-4696-a7ae-891d92b15270.png" alt="Business Logo" /></div>
            {/* Duplicate set for infinite scroll effect */}
            <div className="carousel-logo"><img src="/logos/1f430c4f457e4c3d069dc68d42c7f25f-72600f75-5c89-4a63-bb74-7974aa94c11d.png" alt="Business Logo" /></div>
            <div className="carousel-logo"><img src="/logos/Golda_Glida_Logo-290b2c2f-7cc8-4d4d-8c64-16f23710bca7.png" alt="Golda Logo" className="golda-logo" /></div>
            <div className="carousel-logo"><img src="/logos/1de9b96d4b232eeb21d34f5270915847-fc94815b-ffa3-4f44-8661-3962faa4e4d7.png" alt="Business Logo" /></div>
            <div className="carousel-logo"><img src="/logos/d7b04853d897ebe78aaba7a5c07e2ffa-7977565c-df53-4b8d-8dc0-ceea30dffcc9.png" alt="Business Logo" /></div>
            <div className="carousel-logo"><img src="/logos/Logo-Vector-02-61b74198-2798-48e2-866e-a44bdecd7e08.png" alt="Business Logo" /></div>
            <div className="carousel-logo"><img src="/logos/180039-daf31bdb-362b-480b-93ff-d2fa761d7b88.png" alt="Business Logo" /></div>
            <div className="carousel-logo"><img src="/logos/1320aaf2488d1018360e55b4ad2c772d-e507d50a-6f34-4696-a7ae-891d92b15270.png" alt="Business Logo" /></div>
          </div>
        </div>
      </section>

      {/* Main Video Section */}
      <section className="main-video-section">
        <div className="main-video-container">
          <div className="video-wrapper">
            <video 
              className="custom-video-player"
              controls 
              playsInline 
              preload="metadata"
            >
              <source src="/bali-demo-video.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </section>

      {/* Solutions Section */}
      <section className="solutions-section scroll-animate">
        <div className="section-label">{t.solutionsLabel}</div>
        <h2 className="section-title">{t.solutionsTitle}</h2>
        <p className="section-description">{t.solutionsDescription}</p>
      </section>

      {/* 3 Apps Section */}
      <section className="three-apps-section scroll-animate">
        <div className="section-label">{t.threeAppsLabel}</div>
        <h2 className="section-title">{t.threeAppsTitle}</h2>
        <p className="section-description">{t.threeAppsDescription}</p>
        <div className="apps-grid">
          <div className="app-card hover-lift">
            <span className="app-icon">🏪</span>
            <h3>{t.shopAppTitle}</h3>
            <p className="app-sub">{t.shopAppSub}</p>
            <p>{t.shopAppDesc}</p>
          </div>
          <div className="app-card featured hover-lift">
            <span className="app-icon">🛵</span>
            <h3>{t.driverAppTitle}</h3>
            <p className="app-sub">{t.driverAppSub}</p>
            <p>{t.driverAppDesc}</p>
          </div>
          <div className="app-card hover-lift">
            <span className="app-icon">📊</span>
            <h3>{t.managerAppTitle}</h3>
            <p className="app-sub">{t.managerAppSub}</p>
            <p>{t.managerAppDesc}</p>
          </div>
        </div>
      </section>



      {/* Restaurants Section */}
      <section className="feature-section restaurants-section scroll-animate">
        <div className="feature-content">
          <div className="feature-image mobile-screenshot-container hover-scale">
            <img src="/mobile-app.png" alt="Restaurant App" className="feature-img mobile-img" />
          </div>
          <div className="feature-text">
            <div className="section-label">{t.restaurantsLabel}</div>
            <h2 className="section-title">{t.restaurantsTitle}</h2>
            <p className="section-description">{t.restaurantsDescription}</p>
            <button className="btn-cta">{t.restaurantsCTA}</button>
          </div>
        </div>
      </section>

      {/* Delivery Companies Section */}
      <section className="feature-section delivery-section scroll-animate">
        <div className="feature-content">
          <div className="feature-text">
            <div className="section-label">{t.deliveryLabel}</div>
            <h2 className="section-title">{t.deliveryTitle}</h2>
            <p className="section-description">{t.deliveryDescription}</p>
            <button className="btn-cta">{t.deliveryCTA}</button>
          </div>
          <div className="feature-image mobile-screenshot-container hover-scale">
            <img src="/main-screen.png" alt="Delivery Management" className="feature-img mobile-img" />
          </div>
        </div>
      </section>

      {/* Customization Section */}
      <section className="customization-section scroll-animate">
        <div className="section-label">{t.customLabel}</div>
        <h2 className="section-title">{t.customTitle}</h2>
        <p className="section-description">{t.customDescription}</p>
      </section>

      {/* Automation Section */}
      <section className="automation-section scroll-animate">
        <h3 className="automation-title">{t.automationTitle}</h3>
        <p className="automation-description">{t.automationDesc}</p>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section scroll-animate">
        <div className="section-label">{t.testimonialsLabel}</div>
        <h2 className="section-title">{t.testimonialsTitle}</h2>
        <div className="testimonials-grid">
          {testimonials.map((item, i) => (
            <div key={i} className="testimonial-card hover-lift">
              <h4 className="testimonial-name">{isRtl ? item.name : item.nameEn}</h4>
              <p className="testimonial-role">{isRtl ? item.role : item.roleEn}</p>
              <p className="testimonial-text">"{isRtl ? item.text : item.textEn}"</p>
            </div>
          ))}
        </div>
      </section>

      {/* Coverage / Stats */}
      <section className="coverage-section scroll-animate">
        <div className="section-label">{t.coverageLabel}</div>
        <h2 className="section-title">{t.coverageTitle}</h2>
        <p className="section-description">{t.coverageDescription}</p>
        <div className="stats-container">
          <div className="stat-item hover-lift">
            <h3 className="stat-number">200+</h3>
            <p className="stat-label">{t.stat1}</p>
          </div>
          <div className="stat-item hover-lift">
            <h3 className="stat-number">100+</h3>
            <p className="stat-label">{t.stat2}</p>
          </div>
          <div className="stat-item hover-lift">
            <h3 className="stat-number">20K</h3>
            <p className="stat-label">{t.stat3}</p>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="contact-section scroll-animate" id="contact">
        <div className="contact-container">
          <div className="contact-text">
            <h2>{t.contactTitle}</h2>
            <p>{t.contactSub}</p>
          </div>
          <form className="contact-form" onSubmit={handleSubmit}>
            <input type="text" name="name" placeholder={t.contactName} value={formData.name} onChange={handleInputChange} required />
            <input type="tel" name="phone" placeholder={t.contactPhone} value={formData.phone} onChange={handleInputChange} required />
            <select name="businessType" value={formData.businessType} onChange={handleInputChange} required>
              <option value="עסק">{t.contactBusiness}</option>
              <option value="שליח">{t.contactCourier}</option>
              <option value="מסעדה">{t.contactRestaurant}</option>
            </select>
            <input type="text" name="city" placeholder={t.contactCity} value={formData.city} onChange={handleInputChange} required />
            <button type="submit" className="btn-submit">{t.contactSubmit}</button>
          </form>
        </div>
      </section>

      {/* Final CTA */}
      <section className="final-cta-section scroll-animate">
        <h2>{t.finalCTA}</h2>
        <a href="#contact" className="btn-cta-large pulse-glow">{t.finalBtn}</a>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="footer-content">
          <div className="footer-logo">
            <h3>Bali</h3>
            <p>כל מה שבא לי</p>
          </div>
          <div className="footer-links">
            <a href="#privacy">{isRtl ? 'מדיניות פרטיות' : 'Privacy Policy'}</a>
            <a href="#terms">{isRtl ? 'תקנון האתר' : 'Terms of Service'}</a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2026 Bali Drive. {isRtl ? 'כל הזכויות שמורות' : 'All Rights Reserved'}</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
